import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScrollService } from '@app/core/scroll/scroll.service';
import { MyZoneRoutesEnum } from '@app/my-zone/my-zone-routes.enum';
import { AppRoutesEnum } from '@app/routes';
import { ProductIdEnum, RelationInterface } from 'outshared-lib';
import { Subscription } from 'rxjs';
import { StorageService } from '@inshared/shared/util-storage';

const TARGET_URL = 'targetUrl';

@Component({
    selector: 'ins-my-zone',
    templateUrl: './my-zone.component.html',
    styleUrls: ['./my-zone.component.scss'],
})
export class MyZoneComponent implements OnInit, OnDestroy {
    @Input() loaded: boolean;
    @Input() relation: RelationInterface;
    @Input() ezine: boolean;

    public productIdEnum = ProductIdEnum;

    public get inMyZoneRoot(): boolean {
        return this.router.url.startsWith(`/${AppRoutesEnum.MyZone}/${MyZoneRoutesEnum.MyInsurances}`);
    }

    private subscriptions = new Subscription();

    constructor(
        private renderer: Renderer2,
        private scrollService: ScrollService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private document: Document,
        @Inject(StorageService) private storage: Storage,
    ) {
        // TODO: WINS-5544 - wordt hier nog gebruik van gemaakt?
        this.renderer.addClass(this.document.body, 'mijn-verzekeringsmap');
    }

    public ngOnInit(): void {
        this.storage.removeItem(TARGET_URL);

        this.subscriptions.add(
            this.activatedRoute.fragment.subscribe((params) => {
                if (params) {
                    this.scrollService.scrollElementOffset(`#${params}`, 0, 0);
                }
            }),
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
